import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material/menu';
import { SvgModule } from '@shared/components/svg/svg.module';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DynamicCatalogFilesModule } from '@shared/components/dynamic-catalog-files/dynamic-catalog-files.module';
import { RouterModule } from '@angular/router';
import { DownloadButtonComponent } from './component/download-button.component';
import { DownloadDialogComponent } from './component/download-modal-dialog/download-dialog.component';
import { FavoritesAndSubscribeCatalogModule } from '../favorites-and-subscribe-catalog/favorites-and-subscribe-catalog.module';

@NgModule({
  declarations: [DownloadButtonComponent, DownloadDialogComponent],
  imports: [
    RouterModule,
    CommonModule,
    MatMenuModule,
    SvgModule,
    TranslateModule,
    FavoritesAndSubscribeCatalogModule,
    NgLetModule,
    MatTooltipModule,
    DynamicCatalogFilesModule
  ],
  exports: [DownloadButtonComponent]
})
export class DownloadButtonModule {}
